import { RapydToastTypes, showToast } from '@rapyd/react-ui-library';
import { startCase } from 'lodash-es';
import { ReactElement } from 'react';

interface IProps {
  text: string | ReactElement;
  title?: string;
  type: RapydToastTypes;
  timeout?: number;
}

const setAlert = (props: IProps) => {
  const { type, text, title, timeout } = props;
  return showToast({
    type,
    title: title || startCase(type),
    content: text as string,
    autoClose: timeout || false,
    closeOnClick: false,
    draggable: false,
    position: 'top-center'
  });
};

export default setAlert;

export { RapydToastTypes as AlertTypes };
